export default __webpack_public_path__ + "static/media/settings-error.68850567.svg";